<template>
  <div class="q-edit-content q-select" :class="{ display: !edit }">
    <template v-if="edit">
      <draggable
        ref="drag"
        @update="moved"
        v-model="value.detail.list"
        :options="{ handle: '.sort-item', animation: 200 }"
        @start="drag = true"
        @end="drag = false"
      >
        <div
          v-for="(item, index) in value.detail.list"
          class="q-select-item row"
          :label="index"
          :key="index"
        >
          <div class="sort-item">
            <img width="8" src="https://cnstatic01.e.vhall.com/upload/interacts/screen-imgs/202404/4e/00/4e0048314a03b356b433a19a7e41584a9065.png" alt="" style="cursor: move;">
          </div>
          <span class="select-icon"></span>
          <div class="select-input">
            <com-input
              v-model="item.value"
              placeholder="请输入选项"
              :class="{ error: item.error }"
              @focus="itemFocus(item)"
              :max-length="100"
            ></com-input>
          </div>
          <span
            class="remove"
            v-if="edit && value.detail.list.length > 2"
            @click="delItem(index)"
          >
            <i class="vh-icon-remove-outline"></i>
          </span>
        </div>
      </draggable>
    </template>
    <template v-else>
      <vh-select
        v-if="!edit"
        :disabled="isPreview||isReplay"
        v-model="val"
        @change="change"
        placeholder="请选择"
        size="small"
        class="quiz-select-container"
        popper-class="vmp-quiz-select"
        style="width: 100%"
      >
        <vh-option
          v-for="(item, index) in value.detail.list"
          :label="item.value"
          :value="item.key ? item.key : index"
          :key="index"
        >
        </vh-option>
      </vh-select>
      <div v-if="!edit && errorTip" class="error-msg">
        {{ errorTip }}
      </div>
    </template>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import ComInput from "../input/com.vue";

export default {
  name: 'qSelect',
  props: {
    value: {
      type: Object,
      default() {
        return {};
      },
    },
    isPreview: Boolean,
    isReplay: Boolean,
  },
  inject: ["isH5"],
  components: {
    draggable,
    ComInput,
  },
  data() {
    const otherItem = this.value.detail.list.find(
      (item) => item.custom_opt == 1
    );
    return {
      keyVal: "",
      val: "",
      errorTip: "",
      selectVal: "",
      otherValue: "",
      edit: this.value.ext.edit,
      otherItem,
      drag: false
    };
  },
  mounted() {
    this.$nextTick(() => {
      const container = document.querySelector(".quiz-select-container");
      if (container && this.isH5) {
        const width = container.clientWidth;
        document.querySelector(".vmp-quiz-select").style.width = `${width}px`;
      }
    });
     //回显数据
     if(this.value.replayData){
        this.val = this.value.replayData
      }
  },

  methods: {
    delItem(index) {
      if (this.value.detail.list[index].custom_opt == 1) {
        delete this.value.custom_ques;
      }
      this.value.detail.list.splice(index, 1);
    },
    change(key) {
      this.errorTip = "";
    },
    itemFocus(item) {
      if (item.error) {
        item.error = false;
        item.value = "";
      }
    },
    check() {
      if (this.value.required === "Y" && !this.val) {
        this.errorTip = this.$t("form.form_1083");
        return false;
      }
      return { id: this.value.id, value: this.val };
    },
    moved() {

    }
  },
};
</script>

<style scoped lang="scss">
.q-edit-content {
  position: relative;
  &.display {
    margin-bottom: 0;
    margin-top: 10px;
  }
  .row {
    position: relative;
    margin-bottom: 15px;
    &.display {
      margin-bottom: 0px;
    }
    .sort-item{
      cursor: move;
      position: absolute;
      height: 40px;
      //padding-top: 5px;
      box-sizing: border-box;
      z-index: 2;
      left: 0;
      display: none;
      width: 24px;
      margin-top: -1px;
    }
  }
  ::v-deep {
    .error-msg {
      position: absolute;
      color: #fc5659;
      padding-left: 10px;
      line-height: 20px;
      font-size: 12px;
    }
    .vh-select {
      display: block;
    }
    .q-select-item {
      width: 100%;
      position: relative;
      &:hover{
        .sort-item{
          display: flex;
          align-items: center;
        }
      }
      .select-input {
        padding-right: 35px;
        padding-left: 24px;
      }
      .com-input {
        margin-right: 8px;

        position: relative;
        &.error {
          input {
            border-color: #fc5659;
            color: #fc5659;
          }
          .limit {
            display: none;
            color: #999;
            position: absolute;
            top: 50%;
            right: 8px;
            transform: translateY(-50%);
          }
        }
      }
      .vh-input--small .vh-input__inner {
        border: 0;
      }

      .remove {
        position: absolute;
        cursor: pointer;
        font-size: 20px;
        color: #606266;
        top: 8px;
        right: 8px;
        &:hover {
          color: #fc5659;
        }
      }

      //.sort-item{
      //  cursor: move;
      //  position: absolute;
      //  height: 40px;
      //  padding-top: 5px;
      //  box-sizing: border-box;
      //  z-index: 2;
      //  left: 0;
      //  display: none;
      //}
    }
    .otherItem {
      margin-top: 15px;
      margin-bottom: 7px;
    }
  }
}
</style>
<style lang="scss">
.vmp-quiz-select {
  z-index: 3000 !important;
  max-width: 100%!important;
  .vh-select-dropdown__item {
    white-space: normal;
    line-height: 22px;
    margin: 10px 0;
    height: auto;
  }
  .vh-scrollbar .vh-scrollbar__bar {
    opacity: 1 !important;
    visibility: hidden;
  }
}
</style>
